export default "__VITE_ASSET__7a114082__"